import(/* webpackMode: "eager" */ "/app/src/app/(landing-page)/landing/[lang]/(auth)/layout.tsx");
